import { IUserNotification } from '@tableau/user-notifications-client-core';
import * as _ from 'underscore';

import { GetUserNotificationsResult } from '../redux/GetUserNotificationsResult';



export function getEarlyNotificationTime(): Date {
  //Earlier section is 12 hours ago
  let earlierTime = new Date();
  earlierTime.setHours(earlierTime.getHours() - 12);
  return earlierTime;
}

export function isNullOrUndefined(obj: any) {
  return (obj === null || obj === undefined);
}


export function filterOutNotificationsWithErrors(notificationsResult: GetUserNotificationsResult): GetUserNotificationsResult {
  const resultWithoutErrors: GetUserNotificationsResult = {...notificationsResult};
  resultWithoutErrors.notificationDict = _.pick(resultWithoutErrors.notificationDict,  (notification: IUserNotification<any>) => { return _.isEmpty(notification.errorInfoMap);});
  return resultWithoutErrors;
}